module.exports = __webpack_public_path__ + "f4bc4127fe7edd148a60ca8d7faf7487.mtl";